<template>
  <ex-submenu
    v-if="menu.list && menu.list.length >= 1"
    :menuPopup="menuPopup"
    :class="'menuLevel'+menuLevel"
    :index="menu.menuId + ''"
    :popper-class="'site-sidebar--' + sidebarLayoutSkin + '-popper'">
    <template slot="title">
      <span v-if="menuLevel == 2" class="pointer"></span>
      <icon-svg  v-if="menu.icon" :name="menu.icon || ''" class="site-sidebar__menu-icon"></icon-svg>
      <span>{{ menu.name }}</span>
    </template>
    <sub-menu
            :menuLevel="menuLevel+1"
            v-for="item in menu.list"
            :menuPopup="false"
            :key="item.menuId"
            :menu="item"
            :dynamicMenuRoutes="dynamicMenuRoutes">
    </sub-menu>
  </ex-submenu>
  <el-menu-item v-else :index="menu.menuId + ''"
                :class="'menuLevel'+menuLevel"
                @click="gotoRouteHandle(menu)">
    <icon-svg  v-if="menu.icon" :name="menu.icon || ''" class="site-sidebar__menu-icon"></icon-svg>
    <span>{{ menu.name }}</span>
  </el-menu-item>
</template>
<script>
  import SubMenu from './main-sidebar-sub-menu'
  import {getToken} from "@/utils";

  export default {
    name: 'sub-menu',
    props: {
      menuPopup: {
        type: Boolean,
        required: true
      },
      menuLevel:{
        type:Number,
        default:1,
      },
      menu: {
        type: Object,
        required: true
      },
      dynamicMenuRoutes: {
        type: Array,
        required: true
      }
    },
    components: {
      SubMenu
    },
    computed: {
      sidebarFold: {
        get () { return this.$store.state.common.sidebarFold },
      },
      sidebarLayoutSkin: {
        get() {
          return this.$store.state.common.sidebarLayoutSkin
        }
      }
    },
    methods: {
        startWidthHttp(url){
            return url.startsWith('http://') || url.startsWith('https://');
        },
        // 通过menuId与动态(菜单)路由进行匹配跳转至指定路由
      gotoRouteHandle(menu) {
          if(menu.url && this.startWidthHttp(menu.url)){
              var token = getToken();
              window.open(`${menu.url}?token=${token}`)
              return
          }
          if (menu.routeName) {
          let args
          if(menu.routeArgs){
            args=Object.assign({title:menu.name},menu.routeArgs)
          }else{
            args={title:menu.name}
          }
          this.$router.push({name: menu.routeName,params:args})
          return
        }
        var route = this.dynamicMenuRoutes.filter(item => item.meta.menuId === menu.menuId)
        if (route.length >= 1) {
          this.$router.push({name: route[0].name})
        }
      },
    }
  }
</script>
<style lang="less" scoped >




</style>
